(function () {
  if (window.__joselitoHeaderBound) return;
  window.__joselitoHeaderBound = true;

  var TOP_THRESHOLD = 12;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ticking = false;
  var lastY = window.scrollY || 0;
  var activeHeader = null;
  var MEGA_ROLL_FALLBACK_MS = 750;
  var ACCORDION_FALLBACK_MS = 550;
  var EMPTY_COLLECTION_IMAGE =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  function prefersReducedMotion() {
    return reducedMotion.matches;
  }

  function measureHeader(header) {
    if (!header || isDrawerOpen(header)) return;
    document.documentElement.style.setProperty(
      '--header-height',
      header.offsetHeight + 'px'
    );
  }

  function isDrawerOpen(header) {
    var drawer = header.querySelector('[data-header-drawer]');
    return Boolean(drawer && drawer.open);
  }

  function isMegaOpen(header) {
    return header.classList.contains('site-header--mega-open');
  }

  function isPastTop() {
    return (window.scrollY || 0) >= TOP_THRESHOLD;
  }

  function clamp01(value) {
    if (value < 0) return 0;
    if (value > 1) return 1;
    return value;
  }

  /* M15 runway (200svh grow/shrink) is not page scroll. Header stays put until
     that stage unpins and the user moves again. */
  function isM15SectionPinning(section) {
    var pin = section.querySelector('[data-hero-section-hero-pin]');
    if (!pin) return false;
    var range = section.offsetHeight - pin.offsetHeight;
    if (range <= 0) return false;
    var progress = clamp01(-section.getBoundingClientRect().top / range);
    if (progress > 0 && progress < 1) return true;
    if (progress >= 1) {
      var rect = pin.getBoundingClientRect();
      return rect.top <= 1 && rect.bottom > 80;
    }
    return false;
  }

  function isM15Pinning() {
    if (document.body.classList.contains('template-page-componentes')) return false;
    if (document.body.classList.contains('is-hero-section-hero-pinning')) return true;
    var sections = document.querySelectorAll('[data-hero-section-hero-reveal]');
    for (var i = 0; i < sections.length; i++) {
      if (isM15SectionPinning(sections[i])) return true;
    }
    return false;
  }

  var m15ReleaseY = null;

  function isM15Parked(y) {
    return m15ReleaseY != null && Math.abs(y - m15ReleaseY) < TOP_THRESHOLD;
  }

  function holdM15Chrome(y) {
    if (isM15Pinning()) {
      m15ReleaseY = y;
      return true;
    }
    if (isM15Parked(y)) return true;
    m15ReleaseY = null;
    return false;
  }

  function syncMenuChrome(header) {
    if (!header) return;

    var y = window.scrollY || 0;
    var menuOpen = isMegaOpen(header) || isDrawerOpen(header);
    var sticky = isPastTop() && !holdM15Chrome(y);
    var original = header.getAttribute('data-color-scheme') || 'light-white';
    var keepDarkSticky =
      original === 'dark-brand' || original === 'dark-secondary';
    header.classList.toggle('site-header--menu-open', menuOpen);
    header.classList.toggle('site-header--sticky', sticky);

    var classes = Array.prototype.slice.call(header.classList);
    classes.forEach(function (className) {
      if (className.indexOf('scheme-') === 0) {
        header.classList.remove(className);
      }
    });

    if (menuOpen) {
      header.classList.add('scheme-light-white');
      return;
    }

    if (sticky) {
      header.classList.add(
        keepDarkSticky ? 'scheme-' + original : 'scheme-light-white'
      );
      return;
    }

    header.classList.add('scheme-' + original);
  }

  function setHidden(header, hidden) {
    if (prefersReducedMotion()) {
      header.classList.remove('is-hidden');
      return;
    }
    header.classList.toggle('is-hidden', hidden);
  }

  function onScroll() {
    if (!activeHeader) return;

    var y = window.scrollY || 0;
    var holdChrome = holdM15Chrome(y);

    if (
      holdChrome ||
      prefersReducedMotion() ||
      isDrawerOpen(activeHeader) ||
      isMegaOpen(activeHeader) ||
      y < TOP_THRESHOLD
    ) {
      setHidden(activeHeader, false);
    } else if (y > lastY) {
      setHidden(activeHeader, true);
    } else if (y < lastY) {
      setHidden(activeHeader, false);
    }

    lastY = y;
    syncMenuChrome(activeHeader);
    ticking = false;
  }

  function requestScrollUpdate() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(onScroll);
    }
  }

  var lockedScrollY = 0;

  function lockPageScroll() {
    if (document.documentElement.classList.contains('is-scroll-locked')) return;
    lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('is-scroll-locked');
    document.body.style.top = '-' + lockedScrollY + 'px';
  }

  function unlockPageScroll() {
    if (!document.documentElement.classList.contains('is-scroll-locked')) return;
    document.documentElement.classList.remove('is-scroll-locked');
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
  }

  function clearDisclosureTimer(panel) {
    if (!panel) return;
    if (panel._disclosureTimer) {
      window.clearTimeout(panel._disclosureTimer);
      panel._disclosureTimer = null;
    }
    if (panel._disclosureHandler) {
      panel.removeEventListener('transitionend', panel._disclosureHandler);
      panel._disclosureHandler = null;
    }
  }

  function setDisclosure(panel, open, instant) {
    if (!panel) return;
    clearDisclosureTimer(panel);
    instant = instant || prefersReducedMotion();

    if (open) {
      panel.hidden = false;
      if (instant) {
        panel.classList.add('is-open');
        return;
      }
      panel.classList.remove('is-open');
      void panel.offsetHeight;
      window.requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
      return;
    }

    panel.classList.remove('is-open');
    if (instant || panel.hidden) {
      panel.hidden = true;
      return;
    }

    function finish(event) {
      if (event && event.target !== panel) return;
      if (event && event.propertyName && event.propertyName !== 'grid-template-rows') {
        return;
      }
      clearDisclosureTimer(panel);
      panel.hidden = true;
    }

    panel._disclosureHandler = finish;
    panel.addEventListener('transitionend', finish);
    panel._disclosureTimer = window.setTimeout(finish, ACCORDION_FALLBACK_MS);
  }

  function bindDrawer(header) {
    var drawer = header.querySelector('[data-header-drawer]');
    var openBtn = header.querySelector('[data-header-drawer-open]');
    var closeBtn = header.querySelector('[data-header-drawer-close]');
    if (!drawer || !openBtn || openBtn.dataset.headerBound === 'true') return;

    openBtn.dataset.headerBound = 'true';
    var sheet = drawer.querySelector('[data-header-drawer-sheet]') || drawer;

    function setExpanded(open) {
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function clearDrawerCloseTimer() {
      if (drawer._drawerCloseTimer) {
        window.clearTimeout(drawer._drawerCloseTimer);
        drawer._drawerCloseTimer = null;
      }
      if (drawer._drawerCloseHandler) {
        sheet.removeEventListener('transitionend', drawer._drawerCloseHandler);
        drawer._drawerCloseHandler = null;
      }
    }

    function openDrawer() {
      lockPageScroll();
      if (typeof drawer.showModal === 'function') drawer.showModal();
      setExpanded(true);
      setHidden(header, false);
      syncMenuChrome(header);

      if (prefersReducedMotion()) {
        drawer.classList.add('is-open');
        return;
      }

      drawer.classList.remove('is-open');
      void sheet.offsetWidth;
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
    }

    function requestDrawerClose() {
      if (drawer._drawerClosing) return;

      if (prefersReducedMotion() || !drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        if (drawer.open) drawer.close();
        return;
      }

      drawer._drawerClosing = true;
      drawer.classList.remove('is-open');

      function finish(event) {
        if (event && event.target !== sheet) return;
        if (event && event.propertyName && event.propertyName !== 'transform') {
          return;
        }
        clearDrawerCloseTimer();
        drawer._drawerClosing = false;
        if (drawer.open) drawer.close();
      }

      drawer._drawerCloseHandler = finish;
      sheet.addEventListener('transitionend', finish);
      drawer._drawerCloseTimer = window.setTimeout(finish, MEGA_ROLL_FALLBACK_MS);
    }

    openBtn.addEventListener('click', openDrawer);

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        requestDrawerClose();
      });
    }

    drawer.addEventListener('cancel', function (event) {
      if (prefersReducedMotion()) return;
      event.preventDefault();
      requestDrawerClose();
    });

    drawer.addEventListener('close', function () {
      clearDrawerCloseTimer();
      drawer.classList.remove('is-open');
      drawer._drawerClosing = false;
      setExpanded(false);
      closeAllAccordions(header, true);
      closeLocaleSwitcher(header, true);
      unlockPageScroll();
      syncMenuChrome(header);
    });

    if (drawer.open) {
      lockPageScroll();
      drawer.classList.add('is-open');
      syncMenuChrome(header);
    }
  }

  function closeLocaleSwitcher(header, instant) {
    var switchers = header.querySelectorAll('[data-locale-switcher]');
    switchers.forEach(function (switcher) {
      var trigger = switcher.querySelector('[data-locale-trigger]');
      var menu = switcher.querySelector('[data-locale-menu]');
      switcher.setAttribute('data-open', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu) setDisclosure(menu, false, instant);
    });
  }

  function bindLocaleSwitcher(header) {
    var drawer = header.querySelector('[data-header-drawer]');
    if (!drawer || drawer.dataset.localeBound === 'true') return;
    drawer.dataset.localeBound = 'true';

    var switchers = drawer.querySelectorAll('[data-locale-switcher]');
    switchers.forEach(function (switcher) {
      var trigger = switcher.querySelector('[data-locale-trigger]');
      var menu = switcher.querySelector('[data-locale-menu]');
      if (!trigger || !menu) return;

      trigger.addEventListener('click', function () {
        var willOpen = switcher.getAttribute('data-open') !== 'true';
        closeLocaleSwitcher(header, false);
        if (willOpen) {
          switcher.setAttribute('data-open', 'true');
          trigger.setAttribute('aria-expanded', 'true');
          setDisclosure(menu, true, false);
        }
      });
    });
  }

  function getPanelForTrigger(trigger) {
    var link = trigger.querySelector('[data-mega-link]');
    var panelId = link && link.getAttribute('aria-controls');
    if (!panelId) return null;
    return document.getElementById(panelId);
  }

  function getMegaShell(header) {
    return header.querySelector('[data-mega-shell]');
  }

  function getShellInner(shell) {
    return shell ? shell.querySelector('.site-header__mega-shell-inner') : null;
  }

  function clearShellCloseTimer(shell) {
    if (!shell) return;
    if (shell._megaCloseTimer) {
      window.clearTimeout(shell._megaCloseTimer);
      shell._megaCloseTimer = null;
    }
    if (shell._megaCloseHandler) {
      shell.removeEventListener('transitionend', shell._megaCloseHandler);
      shell._megaCloseHandler = null;
    }
  }

  function clearShellSwitchTimer(shell) {
    if (!shell) return;
    if (shell._megaSwitchTimer) {
      window.clearTimeout(shell._megaSwitchTimer);
      shell._megaSwitchTimer = null;
    }
  }

  function resetPanelState(panel) {
    if (!panel) return;
    panel.classList.remove('is-active', 'is-leaving', 'is-switching');
    panel.style.opacity = '';
    panel.style.transition = '';
    panel.hidden = true;
  }

  function activatePanel(panel) {
    if (!panel) return;
    panel.hidden = false;
    panel.classList.remove('is-leaving', 'is-switching');
    panel.classList.add('is-active');
    panel.style.opacity = '';
    panel.style.transition = '';
  }

  function setShellInnerHeight(shell, heightPx, instant) {
    var inner = getShellInner(shell);
    if (!inner) return;

    if (instant || prefersReducedMotion()) {
      var previous = inner.style.transition;
      inner.style.transition = 'none';
      inner.style.height = heightPx == null ? '' : heightPx + 'px';
      void inner.offsetHeight;
      inner.style.transition = previous;
      return;
    }

    inner.style.height = heightPx == null ? '' : heightPx + 'px';
  }

  function clearShellInnerHeight(shell) {
    var inner = getShellInner(shell);
    if (!inner) return;
    inner.style.height = '';
  }

  function measureActivePanelHeight(shell) {
    var active = shell.querySelector('[data-mega-panel].is-active');
    if (!active) return 0;
    return active.scrollHeight;
  }

  function finishPanelSwitch(shell) {
    clearShellSwitchTimer(shell);
    if (!shell) return;
    shell.classList.remove('is-switching-panels');
    shell.querySelectorAll('[data-mega-panel].is-leaving').forEach(function (panel) {
      resetPanelState(panel);
    });
    var active = shell.querySelector('[data-mega-panel].is-active');
    if (active) {
      active.style.opacity = '';
      active.style.transition = '';
    }
  }

  function switchMegaPanel(shell, nextPanel, previousPanel) {
    if (!shell || !nextPanel) return;

    clearShellSwitchTimer(shell);
    shell._megaSwitchGen = (shell._megaSwitchGen || 0) + 1;
    var switchGen = shell._megaSwitchGen;

    var fromHeight = measureActivePanelHeight(shell);
    if (!fromHeight) {
      var inner = getShellInner(shell);
      fromHeight = inner ? inner.offsetHeight : 0;
    }

    shell.querySelectorAll('[data-mega-panel].is-leaving').forEach(function (panel) {
      if (panel !== previousPanel && panel !== nextPanel) {
        resetPanelState(panel);
      }
    });

    var instant = prefersReducedMotion();

    if (instant || !previousPanel || previousPanel === nextPanel) {
      if (previousPanel && previousPanel !== nextPanel) {
        resetPanelState(previousPanel);
      }
      activatePanel(nextPanel);
      resetCollectionHover(nextPanel);
      setShellInnerHeight(shell, nextPanel.scrollHeight, true);
      finishPanelSwitch(shell);
      return;
    }

    /* Prep overlapping crossfade: lock start opacities, then transition together */
    shell.classList.add('is-switching-panels');

    previousPanel.hidden = false;
    previousPanel.classList.remove('is-active');
    previousPanel.classList.add('is-leaving');
    previousPanel.style.transition = 'none';
    previousPanel.style.opacity = '1';

    nextPanel.hidden = false;
    nextPanel.classList.remove('is-leaving', 'is-switching');
    nextPanel.classList.add('is-active');
    nextPanel.style.transition = 'none';
    nextPanel.style.opacity = '0';
    resetCollectionHover(nextPanel);

    var toHeight = nextPanel.scrollHeight;
    setShellInnerHeight(shell, fromHeight, true);
    void shell.offsetWidth;

    window.requestAnimationFrame(function () {
      if (shell._megaSwitchGen !== switchGen) return;

      previousPanel.style.transition = '';
      previousPanel.style.opacity = '';
      nextPanel.style.transition = '';
      nextPanel.style.opacity = '';
      setShellInnerHeight(shell, toHeight, false);
    });

    shell._megaSwitchTimer = window.setTimeout(function () {
      if (shell._megaSwitchGen !== switchGen) return;
      finishPanelSwitch(shell);
    }, ACCORDION_FALLBACK_MS);
  }

  function setActiveTrigger(header, activeTrigger) {
    var triggers = header.querySelectorAll('[data-mega-trigger]');
    triggers.forEach(function (trigger) {
      var isActive = trigger === activeTrigger;
      trigger.classList.toggle('is-active', isActive);
      var link = trigger.querySelector('[data-mega-link]');
      if (link) link.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  }

  function closeMega(header, options) {
    options = options || {};
    var instant = options.instant || prefersReducedMotion();
    var shell = getMegaShell(header);

    setActiveTrigger(header, null);

    var panels = header.querySelectorAll('[data-mega-panel]');

    if (!shell) {
      panels.forEach(resetPanelState);
      header.classList.remove('site-header--mega-open');
      syncMenuChrome(header);
      return;
    }

    clearShellSwitchTimer(shell);
    shell.classList.remove('is-switching-panels');

    if (instant) {
      clearShellCloseTimer(shell);
      shell.classList.remove('is-open');
      shell.hidden = true;
      clearShellInnerHeight(shell);
      panels.forEach(resetPanelState);
      header.classList.remove('site-header--mega-open');
      syncMenuChrome(header);
      return;
    }

    if (shell.hidden && !shell.classList.contains('is-open')) {
      panels.forEach(resetPanelState);
      clearShellInnerHeight(shell);
      header.classList.remove('site-header--mega-open');
      syncMenuChrome(header);
      return;
    }

    clearShellCloseTimer(shell);
    shell.hidden = false;
    shell.classList.remove('is-open');

    function finishClose(event) {
      if (event && event.propertyName && event.propertyName !== 'transform') {
        return;
      }
      clearShellCloseTimer(shell);
      panels.forEach(resetPanelState);
      clearShellInnerHeight(shell);
      shell.hidden = true;
      header.classList.remove('site-header--mega-open');
      syncMenuChrome(header);
    }

    shell._megaCloseHandler = finishClose;
    shell.addEventListener('transitionend', finishClose);
    shell._megaCloseTimer = window.setTimeout(finishClose, MEGA_ROLL_FALLBACK_MS);
  }

  function clearCollectionImage(media) {
    if (!media) return;

    if (media._megaFadeTimer) {
      window.clearTimeout(media._megaFadeTimer);
      media._megaFadeTimer = null;
    }
    if (media._megaFadeHandler) {
      media.removeEventListener('transitionend', media._megaFadeHandler);
      media._megaFadeHandler = null;
    }

    media.classList.remove('is-visible', 'is-fading');
    media.setAttribute('src', EMPTY_COLLECTION_IMAGE);
    media.removeAttribute('srcset');
    media.alt = '';
  }

  function hideCollectionImage(media) {
    if (!media) return;

    var reduced =
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible =
      media.classList.contains('is-visible') &&
      media.getAttribute('src') &&
      media.getAttribute('src') !== EMPTY_COLLECTION_IMAGE;

    if (reduced || !visible) {
      clearCollectionImage(media);
      return;
    }

    if (media._megaFadeTimer) {
      window.clearTimeout(media._megaFadeTimer);
      media._megaFadeTimer = null;
    }
    if (media._megaFadeHandler) {
      media.removeEventListener('transitionend', media._megaFadeHandler);
      media._megaFadeHandler = null;
    }

    media.classList.add('is-fading');

    function onFadedOut(event) {
      if (event && event.propertyName && event.propertyName !== 'opacity') return;
      clearCollectionImage(media);
    }

    media._megaFadeHandler = onFadedOut;
    media.addEventListener('transitionend', onFadedOut);
    media._megaFadeTimer = window.setTimeout(onFadedOut, 380);
  }

  function resetCollectionHover(panel) {
    if (!panel || panel.getAttribute('data-mega-layout') !== 'collections') return;

    var links = panel.querySelectorAll('[data-mega-collection-link]');
    var media = panel.querySelector('[data-mega-collection-media]');

    links.forEach(function (el) {
      el.classList.remove('is-active');
    });

    panel._megaActiveLink = null;
    clearCollectionImage(media);
  }

  function swapCollectionImage(media, nextSrc, nextAlt) {
    if (!media || !nextSrc) return;

    var reduced =
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasImage =
      media.classList.contains('is-visible') &&
      media.getAttribute('src') &&
      media.getAttribute('src') !== EMPTY_COLLECTION_IMAGE;

    function applyImage() {
      media.setAttribute('src', nextSrc);
      media.removeAttribute('srcset');
      if (nextAlt != null) media.alt = nextAlt;
    }

    function fadeIn() {
      media.classList.remove('is-fading');
      media.classList.add('is-visible');
    }

    function clearFadeTimer() {
      if (media._megaFadeTimer) {
        window.clearTimeout(media._megaFadeTimer);
        media._megaFadeTimer = null;
      }
      if (media._megaFadeHandler) {
        media.removeEventListener('transitionend', media._megaFadeHandler);
        media._megaFadeHandler = null;
      }
    }

    if (reduced || !hasImage) {
      clearFadeTimer();
      applyImage();
      fadeIn();
      return;
    }

    clearFadeTimer();

    // Restart fade-out from full opacity so the transition always runs
    media.classList.remove('is-fading');
    void media.offsetWidth;
    media.classList.add('is-fading');

    function onFadedOut(event) {
      if (event && event.propertyName && event.propertyName !== 'opacity') return;
      clearFadeTimer();
      applyImage();
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(fadeIn);
      });
    }

    media._megaFadeHandler = onFadedOut;
    media.addEventListener('transitionend', onFadedOut);

    // Fallback if transitionend does not fire (same src, interrupted, etc.)
    media._megaFadeTimer = window.setTimeout(onFadedOut, 380);
  }

  function lockShellHeightAfterOpen(shell) {
    if (!shell) return;

    function lockHeight(event) {
      if (event && event.propertyName && event.propertyName !== 'transform') {
        return;
      }
      if (shell._megaOpenHandler) {
        shell.removeEventListener('transitionend', shell._megaOpenHandler);
        shell._megaOpenHandler = null;
      }
      if (shell._megaOpenTimer) {
        window.clearTimeout(shell._megaOpenTimer);
        shell._megaOpenTimer = null;
      }
      if (!shell.classList.contains('is-open') || shell.hidden) return;
      setShellInnerHeight(shell, measureActivePanelHeight(shell), true);
    }

    if (shell._megaOpenHandler) {
      shell.removeEventListener('transitionend', shell._megaOpenHandler);
      shell._megaOpenHandler = null;
    }
    if (shell._megaOpenTimer) {
      window.clearTimeout(shell._megaOpenTimer);
      shell._megaOpenTimer = null;
    }

    if (prefersReducedMotion()) {
      setShellInnerHeight(shell, measureActivePanelHeight(shell), true);
      return;
    }

    shell._megaOpenHandler = lockHeight;
    shell.addEventListener('transitionend', lockHeight);
    shell._megaOpenTimer = window.setTimeout(lockHeight, MEGA_ROLL_FALLBACK_MS);
  }

  function openMega(header, trigger) {
    var panel = getPanelForTrigger(trigger);
    var shell = getMegaShell(header);
    if (!panel || !shell) return;

    var shellAlreadyOpen =
      header.classList.contains('site-header--mega-open') &&
      shell.classList.contains('is-open') &&
      !shell.hidden;

    var samePanel =
      trigger.classList.contains('is-active') && panel.classList.contains('is-active');

    if (shellAlreadyOpen && samePanel) return;

    clearShellCloseTimer(shell);

    var previousPanel = shell.querySelector('[data-mega-panel].is-active');

    setActiveTrigger(header, trigger);
    header.classList.add('site-header--mega-open');
    setHidden(header, false);
    syncMenuChrome(header);

    if (shellAlreadyOpen) {
      switchMegaPanel(shell, panel, previousPanel);
      return;
    }

    header.querySelectorAll('[data-mega-panel]').forEach(function (otherPanel) {
      if (otherPanel !== panel) resetPanelState(otherPanel);
    });
    activatePanel(panel);
    resetCollectionHover(panel);
    clearShellInnerHeight(shell);

    if (prefersReducedMotion()) {
      shell.hidden = false;
      shell.classList.add('is-open');
      setShellInnerHeight(shell, measureActivePanelHeight(shell), true);
      return;
    }

    shell.hidden = false;
    shell.classList.remove('is-open');
    void shell.offsetWidth;
    window.requestAnimationFrame(function () {
      shell.classList.add('is-open');
      lockShellHeightAfterOpen(shell);
    });
  }

  function bindCollectionHover(header) {
    var panels = header.querySelectorAll('[data-mega-panel][data-mega-layout="collections"]');
    panels.forEach(function (panel) {
      if (panel.dataset.collectionBound === 'true') return;
      panel.dataset.collectionBound = 'true';

      var media = panel.querySelector('[data-mega-collection-media]');
      var list = panel.querySelector('.mega-collections__list');
      var links = panel.querySelectorAll('[data-mega-collection-link]');

      function clearHoverState() {
        links.forEach(function (el) {
          el.classList.remove('is-active');
        });
        panel._megaActiveLink = null;
        hideCollectionImage(media);
      }

      links.forEach(function (link) {
        function activate(event) {
          if (event) event.stopPropagation();
          if (panel._megaActiveLink === link) return;

          links.forEach(function (el) {
            el.classList.remove('is-active');
          });
          link.classList.add('is-active');
          panel._megaActiveLink = link;

          if (media && link.getAttribute('data-mega-image')) {
            var label = link.querySelector('.mega-collections__label');
            var nextAlt = label ? label.textContent.trim() : '';
            swapCollectionImage(media, link.getAttribute('data-mega-image'), nextAlt);
          }
        }

        link.addEventListener('pointerenter', activate);
        link.addEventListener('focusin', activate);
      });

      if (list) {
        list.addEventListener('pointerleave', clearHoverState);
        list.addEventListener('focusout', function (event) {
          var related = event.relatedTarget;
          if (related && list.contains(related)) return;
          clearHoverState();
        });
      }
    });
  }

  function bindMega(header) {
    if (header.dataset.megaBound === 'true') return;
    header.dataset.megaBound = 'true';

    var shell = getMegaShell(header);
    var triggers = header.querySelectorAll('[data-mega-trigger]');
    if (!triggers.length || !shell) return;

    bindCollectionHover(header);

    triggers.forEach(function (trigger) {
      var panel = getPanelForTrigger(trigger);
      if (!panel) return;

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (trigger.classList.contains('is-active') && isMegaOpen(header)) {
          closeMega(header);
          return;
        }
        openMega(header, trigger);
      });
    });
  }

  function isMegaOutsideClick(header, target) {
    if (!header || !target) return true;
    var shell = getMegaShell(header);
    if (shell && shell.contains(target)) return false;
    if (target.closest && target.closest('[data-mega-trigger]')) return false;
    return true;
  }

  function closeAllAccordions(header, instant) {
    var toggles = header.querySelectorAll('[data-accordion-toggle]');
    var panels = header.querySelectorAll('[data-accordion-panel]');
    toggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
    panels.forEach(function (panel) {
      setDisclosure(panel, false, instant);
    });
  }

  function bindAccordion(header) {
    var drawer = header.querySelector('[data-header-drawer]');
    if (!drawer || drawer.dataset.accordionBound === 'true') return;
    drawer.dataset.accordionBound = 'true';

    var toggles = drawer.querySelectorAll('[data-accordion-toggle]');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var panelId = toggle.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;

        var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
        closeAllAccordions(header, false);

        if (willOpen) {
          toggle.setAttribute('aria-expanded', 'true');
          setDisclosure(panel, true, false);
        }
      });
    });
  }

  function findHeader() {
    var headers = document.querySelectorAll('[data-site-header]');
    for (var i = 0; i < headers.length; i++) {
      var section = headers[i].closest('.shopify-section');
      if (section && (section.hidden || section.classList.contains('showcase-is-hidden'))) {
        continue;
      }
      return headers[i];
    }
    return headers[0] || null;
  }

  function setActiveHeader(header) {
    activeHeader = header || findHeader();
    if (!activeHeader) return;
    measureHeader(activeHeader);
    lastY = window.scrollY || 0;
    onScroll();
  }

  function initHeader(header) {
    if (!header) return;
    header.dataset.megaBound = '';
    var drawer = header.querySelector('[data-header-drawer]');
    if (drawer) {
      drawer.dataset.accordionBound = '';
      drawer.dataset.localeBound = '';
      drawer.classList.remove('is-open');
      drawer._drawerClosing = false;
    }
    var openBtn = header.querySelector('[data-header-drawer-open]');
    if (openBtn) openBtn.dataset.headerBound = '';
    header.querySelectorAll('[data-mega-panel]').forEach(function (panel) {
      panel.dataset.collectionBound = '';
    });
    var shell = header.querySelector('[data-mega-shell]');
    if (shell) {
      clearShellCloseTimer(shell);
      clearShellSwitchTimer(shell);
      if (shell._megaOpenHandler) {
        shell.removeEventListener('transitionend', shell._megaOpenHandler);
        shell._megaOpenHandler = null;
      }
      if (shell._megaOpenTimer) {
        window.clearTimeout(shell._megaOpenTimer);
        shell._megaOpenTimer = null;
      }
      shell.classList.remove('is-open', 'is-switching-panels');
      clearShellInnerHeight(shell);
      shell.querySelectorAll('[data-mega-panel]').forEach(resetPanelState);
    }

    bindDrawer(header);
    bindMega(header);
    bindAccordion(header);
    bindLocaleSwitcher(header);
  }

  function init() {
    document.querySelectorAll('[data-site-header]').forEach(initHeader);
    setActiveHeader(findHeader());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('scroll', requestScrollUpdate, { passive: true });
  window.addEventListener('resize', function () {
    measureHeader(activeHeader || findHeader());
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !activeHeader || !isMegaOpen(activeHeader)) return;
    closeMega(activeHeader);
  });

  document.addEventListener('click', function (event) {
    if (!activeHeader || !isMegaOpen(activeHeader)) return;
    if (!isMegaOutsideClick(activeHeader, event.target)) return;
    closeMega(activeHeader);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector
      ? event.target.querySelector('[data-site-header]')
      : null;
    if (!header && event.target.matches && event.target.matches('[data-site-header]')) {
      header = event.target;
    }
    if (header) {
      initHeader(header);
      setActiveHeader(header);
    }
  });

  document.addEventListener('joselito:showcase-module', function () {
    setActiveHeader(findHeader());
  });

  document.addEventListener('joselito:header-chrome', function () {
    syncMenuChrome(activeHeader || findHeader());
  });
})();
